import { useEffect, useRef } from "react";
import { Download, Share2 } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

const W = 1080;
const H = 1920;

export const ReferralPost = () => {
  const { t } = useLang();
  const rp = t.dash.referralPost;
  const canvasRef = useRef(null);

  useEffect(() => {
    const ctx = canvasRef.current.getContext("2d");
    ctx.fillStyle = "#0a0a0a";
    ctx.fillRect(0, 0, W, H);
    const g = ctx.createRadialGradient(W / 2, 700, 50, W / 2, 700, 1100);
    g.addColorStop(0, "rgba(255,121,0,0.25)");
    g.addColorStop(1, "rgba(255,121,0,0)");
    ctx.fillStyle = g;
    ctx.fillRect(0, 0, W, H);
    ctx.textAlign = "center";
    ctx.fillStyle = "#ffffff";
    ctx.font = "600 46px Arial";
    ctx.fillText("Smart Telecom Advisor", W / 2, 220);
    ctx.fillStyle = "#FF7900";
    ctx.font = "700 40px Arial";
    ctx.fillText("PROGRAMME DE PARRAINAGE", W / 2, 360);
    ctx.fillStyle = "#ffffff";
    ctx.font = "800 230px Arial";
    ctx.fillText("−5%", W / 2, 640);
    ctx.font = "700 46px Arial";
    ctx.fillText("par mois, À VIE,", W / 2, 750);
    ctx.fillText("par référence qui souscrit", W / 2, 815);
    ctx.fillText("un mobile Orange", W / 2, 880);
    ctx.strokeStyle = "rgba(255,255,255,0.15)";
    ctx.lineWidth = 2;
    ctx.beginPath();
    ctx.moveTo(200, 980);
    ctx.lineTo(880, 980);
    ctx.stroke();
    ctx.fillStyle = "#FBBC04";
    ctx.font = "800 110px Arial";
    ctx.fillText("20 références", W / 2, 1130);
    ctx.fillStyle = "#ffffff";
    ctx.font = "700 52px Arial";
    ctx.fillText("= 100% de réduction sur un des", W / 2, 1230);
    ctx.fillText("numéros de votre facture mobile !", W / 2, 1300);
    ctx.fillStyle = "rgba(255,255,255,0.55)";
    ctx.font = "400 38px Arial";
    ctx.fillText("Donnez simplement mon nom lors de la souscription.", W / 2, 1430);
    ctx.fillStyle = "#FF7900";
    ctx.font = "700 52px Arial";
    ctx.fillText("+32 473 22 33 44", W / 2, 1650);
    ctx.fillStyle = "rgba(255,255,255,0.6)";
    ctx.font = "400 42px Arial";
    ctx.fillText("www.smartelecomadvisor.be", W / 2, 1730);
  }, []);

  const download = () => {
    const a = document.createElement("a");
    a.href = canvasRef.current.toDataURL("image/png");
    a.download = "parrainage-smartsn.png";
    a.click();
  };

  return (
    <div className="bg-[#111111] border border-white/10 p-6 md:p-8 mt-8" data-testid="referral-post-panel">
      <p className="flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-white/40 mb-2">
        <Share2 className="w-4 h-4 text-[#FF7900]" /> {rp.title}
      </p>
      <p className="text-xs text-white/40 mb-5">{rp.hint}</p>
      <div className="flex flex-col md:flex-row gap-6 items-start">
        <button
          onClick={download}
          data-testid="referral-post-download"
          className="inline-flex items-center gap-2 bg-[#FF7900] hover:bg-white hover:text-black text-white text-sm font-semibold px-5 py-2.5 rounded-full transition-colors duration-300"
        >
          <Download className="w-4 h-4" /> {rp.download}
        </button>
        <canvas ref={canvasRef} width={W} height={H} data-testid="referral-post-canvas" className="w-[200px] rounded-xl border border-white/10 shrink-0 shadow-2xl" />
      </div>
    </div>
  );
};
